/** Định danh DÒNG cho vật tư trên đơn hàng.
 *
 *  Cần thiết vì cùng một vật tư nay xuất hiện được trên nhiều dòng (giống sản
 *  phẩm), nên cặp (material_id, line_key) không còn phân biệt được dòng nào là
 *  dòng nào khi sửa số lượng / giá / CK / xoá.
 *
 *  Id chỉ sống ở phía client trong lúc soạn đơn — payload gửi lên không mang
 *  nó, backend phân biệt dòng bằng order_item_id.
 */

/** Sinh id khi môi trường không có `crypto.randomUUID` (vd truy cập qua HTTP
 *  không bảo mật — randomUUID chỉ tồn tại trong secure context).
 *
 *  `rand` tiêm được để test ca `Math.random()` trả giá trị ít chữ số: 0.5 →
 *  `toString(36)` ra `"0.i"`, cắt thô sẽ còn đúng 1 ký tự và dễ trùng. Dùng 2
 *  lần random + padEnd để phần ngẫu nhiên luôn đủ dài. */
export function fallbackRowId(rand: () => number = Math.random): string {
    const chunk = () => rand().toString(36).slice(2).padEnd(8, '0').slice(0, 8)
    return `mat-${Date.now().toString(36)}-${chunk()}${chunk()}`
}

export function newMaterialRowId(): string {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
        return crypto.randomUUID()
    }
    return fallbackRowId()
}

/** Khoá ổn định của một dòng vật tư — dùng cho cả React key lẫn việc tìm dòng
 *  khi sửa/xoá.
 *
 *  Dòng thêm tay có `row_id` riêng. Dòng do BOM/surcharge sinh không có
 *  `row_id` nhưng đã duy nhất theo (line_key, material_id), nên fallback về
 *  cặp đó. KHÔNG được khoá bằng riêng material_id: hai dòng thêm tay cùng vật
 *  tư sẽ trùng khoá, khiến sửa dòng này đổi luôn dòng kia. */
export function rowKeyOf(row: {
    row_id?: string
    line_key: string
    packaging_material_id: string
}): string {
    return row.row_id || `${row.line_key}::${row.packaging_material_id}`
}
